import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const TooltipWrapper = styled.div`
  position: absolute;
  background: #00819b;
  width: 236px;
  height: 75px;
  min-width: 236px;
  min-height: 59px;
  border: 1px solid #00819b;
  border-radius: 6px;
  ::before {
    content: '';
    position: absolute;
    left: 10px;
    top: -9.5px;
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 9.1px solid #00819b;
    clear: both;
  }
  z-index: 10;
  padding: 12px;
  top: 40px;
  left: 10px;
`;
const Text = styled.div`
  color: #ffffff;
  font-family: Roboto;
  font-size: 10px;
  font-weight: 400;
  line-height: 14px;
`;
const Button = styled.button`
  width: 70px;
  height: 15px;
  color: #ffffff;
  font-family: Lato;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: -0.02px;
  text-transform: uppercase;
  background: #00819b;
  border: none;
  position: absolute;
  bottom: 12px;
  right: 8px;
  outline: none;
  :hover {
    background: #4ca6b9;
  }
`;

const CancelledTranscripTooltip = ({ resubmitTranscript }) => (
  <TooltipWrapper>
    <Text>
      The order to REV was canceled.
      <br />
      To send again, click the RE-SUBMIT button.
    </Text>
    <Button
      onClick={(e) => {
        e.stopPropagation();
        resubmitTranscript();
      }}
    >
      RE-SUBMIT
    </Button>
  </TooltipWrapper>
);
CancelledTranscripTooltip.propTypes = {
  resubmitTranscript: PropTypes.func.isRequired,
};
export default CancelledTranscripTooltip;



// WEBPACK FOOTER //
// ./components/molecules/CancelledTranscriptTooltip.js